/* eslint-disable no-console */

import { register, unregister } from "register-service-worker";
import axios from "axios";

if (process.env.NODE_ENV === "production") {
  const checkUpdate = async (ignoreEmptyEtag: boolean) => {
    const param = new Date().getTime();
    const res = await axios.head(`/index.html?p=${param}`);
    const new_etag = res.headers.etag;
    const key = "__CURRENT_INDEX_ETAG__";
    if (window.localStorage) {
      const current_etag = window.localStorage.getItem(key);
      if ((!ignoreEmptyEtag && !current_etag) || new_etag !== current_etag) {
        window.localStorage.setItem(key, new_etag);
        console.log(`New content is available; please refresh: current=${current_etag} / new=${new_etag}`);

        if (window.caches) {
          console.log("---------clear cache---------");
          const keys = await window.caches.keys();
          await Promise.all(
            keys.map((key) => {
              console.log(key);
              window.caches.delete(key);
            })
          );
        }
        unregister();
        // window.localStorage.setItem("___RELOAD_NEEDED__", "true");
        // window.localStorage.setItem("__ORIGINAL_PATH__", window.location.href);
        // location.replace("/");
      } else {
        console.log(`Latest version(not changed) : current=${current_etag} / new=${new_etag}`);
      }
    }
  };

  register(`${process.env.BASE_URL}firebase-messaging-sw.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" + "For more details, visit https://goo.gl/AFskqB"
      );
    },
    async registered(registration) {
      console.log("Service worker has been registered.");
      console.log(registration);

      await checkUpdate(true);
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    async updated() {
      console.log("***** Version Check *****");
      await checkUpdate(false);
    },
    offline() {
      console.log("No internet connection found. App is running in offline mode.");
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
    registrationOptions: {
      updateViaCache: "all",
    },
  });
}
